//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as storeApi from '@/api/store';
export default {
  components: {},
  data: function data() {
    return {
      visible: false,
      maxNum: 1,
      maxPage: 1,
      inputNum: 1,
      listPram: {}
    };
  },
  mounted: function mounted() {},
  methods: {
    openInit: function openInit() {
      var listPram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var maxNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      this.listPram = listPram;
      this.inputNum = 1;
      this.maxNum = maxNum;
      this.maxPage = Math.ceil(Number(Number(maxNum) / 10000));
      this.visible = true;
    },
    handerSubmit: function handerSubmit() {
      var _this = this;
      if (!this.inputNum) {
        this.$message.warning('请输入导出页码！');
        return;
      }
      ;
      storeApi.exportJdGoods(this.listPram, this.inputNum).then(function (res) {
        window.open(res.fileName);
        _this.visible = false;
      });
    },
    closeEdit: function closeEdit() {
      this.visible = false;
    }
  }
};